import { client, gql } from 'data-provider';
import { IAddress, ICompanyConfig } from 'interfaces';

export const getAllCompanyConfig = async () => {
  const query = gql`
    query {
      CompanyConfigs {
        id
        companyName
        companyEmail
        companyNumber
        companyWebsite
        companyBinNo
        companyVatNo
      }
    }
  `;
  const data = await client.request(query);
  return data.CompanyConfigs as ICompanyConfig[];
};

export const getCompanyInfo = async (companyConfigId: string) => {
  const companyQuery = gql`
    query ($companyConfigId: ID!) {
      CompanyConfig(id: $companyConfigId) {
        id
        companyName
        companyEmail
        companyNumber
        companyWebsite
        companyBinNo
        companyVatNo
        address {
          id
          street
          area
          city
          country
          zip
        }
        companyConfigPhoto {
          avatar {
            uid
            name
            url
            thumbUrl
            size
            type
            lastModifiedDate
          }
        }
      }
    }
  `;
  const variables = {
    companyConfigId,
  };
  const data = await client.request(companyQuery, variables);
  return data.CompanyConfig as ICompanyConfig;
};

export interface IUpdateCompanyInfoParam {
  companyName: string;
  companyEmail: string;
  companyNumber: string;
  companyWebsite: string;
  companyVatNo?: string | null;
  companyBinNo?: string | null;
  address: IAddress;
  avatar: any[];
}

export const updateCompanyInfo = async (id: string, data: IUpdateCompanyInfoParam) => {
  const updateInfo = gql`
    mutation ($input: updateCompanyConfigInput) {
      updateCompanyConfig(input: $input) {
        id
        companyName
        companyEmail
        companyNumber
        companyWebsite
        companyBinNo
        companyVatNo
        address {
          id
          street
          area
          city
          country
          zip
        }
        companyConfigPhoto {
          avatar {
            uid
            name
            url
            thumbUrl
            size
            type
            lastModifiedDate
          }
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
      data,
    },
  };
  const updatedData = await client.request(updateInfo, variables);
  return updatedData.updateCompanyConfig;
};
